export default __webpack_public_path__ + "static/media/Career.6c32e141.webp";